export enum AppTenant {
  ReferenceTenant = 'reference-tenant',
  HighmarkIel = 'highmark-cs-iel',
  HighmarkBeneficity = 'highmark-cs-beneficity',
  HighmarkAllMyHealth = 'highmark-cs-allmyhealth',
}
